<template>
  <v-menu v-model="menuOpen" :close-on-content-click="false" location="bottom start" offset="8">
    <template #activator="{ props }">
      <v-badge :content="activeCount" :model-value="activeCount > 0" color="brand-color">
        <v-btn v-bind="props" variant="tonal" color="brand-color" rounded="lg" density="comfortable"
          prepend-icon="mdi-filter-plus">
          Add Filter
        </v-btn>
      </v-badge>
    </template>

    <v-card rounded="lg" elevation="3" min-width="420">
      <v-row no-gutters>
        <v-col cols="4">
          <v-list density="compact">
            <v-list-item v-for="group in groups" :key="group.key" :active="activeCategory === group.key" color="primary"
              @click="activeCategory = group.key">
              <template #title>
                <span class="text-body-medium">{{ group.label }}</span>
              </template>
              <template #append>
                <v-icon v-if="draftCountFor(group.key)" icon="mdi-circle" size="8" color="accent-color" />
              </template>
            </v-list-item>
          </v-list>
        </v-col>

        <v-divider vertical />

        <v-col cols="8">
          <v-list density="compact">
            <v-list-item v-for="option in currentGroup.options" :key="option.value"
              @click="toggleDraft(currentGroup.key, option.value, !isDraftChecked(currentGroup.key, option.value))">
              <template #prepend>
                <v-checkbox-btn :model-value="isDraftChecked(currentGroup.key, option.value)"
                  @click.stop @update:model-value="toggleDraft(currentGroup.key, option.value, $event)" />
              </template>
              <template #title>
                <span class="text-body-medium">{{ option.title }}</span>
              </template>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn variant="outlined" color="outlined-color" rounded="lg" size="small" @click="clearDraft">Clear</v-btn>
            <v-btn variant="flat" color="brand-color" rounded="lg" size="small" @click="applyDraft">Apply</v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
import userFiltersMixin from '@/mixins/user/filters'

export default {
  name: 'UserFilterMenu',
  mixins: [userFiltersMixin],
  data() {
    return {
      menuOpen: false,
      activeCategory: 'role',
      draft: { role: [], status: [], payment: [], plan: [] }
    }
  },
  computed: {
    currentGroup() {
      return this.groups.find(group => group.key === this.activeCategory)
    }
  },
  watch: {
    menuOpen(isOpen) {
      if (isOpen) {
        this.activeCategory = 'role'
        this.draft = {
          role: [...(this.modelValue.role || [])],
          status: [...(this.modelValue.status || [])],
          payment: [...(this.modelValue.payment || [])],
          plan: [...(this.modelValue.plan || [])]
        }
      }
    }
  },
  methods: {
    draftCountFor(group) {
      return (this.draft[group] || []).length
    },
    isDraftChecked(group, value) {
      return (this.draft[group] || []).includes(value)
    },
    toggleDraft(group, value, checked) {
      const current = this.draft[group] || []
      this.draft = {
        ...this.draft,
        [group]: checked ? [...current, value] : current.filter(v => v !== value)
      }
    },
    clearDraft() {
      this.draft = { role: [], status: [], payment: [], plan: [] }
    },
    applyDraft() {
      this.$emit('update:modelValue', { ...this.draft })
      this.menuOpen = false
    }
  }
}
</script>
